import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import {
  deleteBlog,
  deleteCourseFees,
  getBlog,
  getColleges,
  getCourseCategories,
  getCourseFees,
  getCourses,
  getUniversities,
  updateBlog,
  updateCourseFees,
} from "../../Services/HomeService";
import moment from "moment";
import HttpClientXml from "../../utils/HttpClientXml";
import Swal from "sweetalert2";
import "./Style.css";
import Select from "react-select";
import ReactQuill from "react-quill";
import { getPlainTextFromHtml } from "../../utils/Helper";

const tabNames = [
  {
    value: "Overview",
    label: "Overview",
  },
  {
    value: "Courses & Fees",
    label: "Courses & Fees",
  },

  {
    value: "Admission",
    label: "Admission",
  },
  {
    value: "Scholarship",
    label: "Scholarship",
  },
  {
    value: "Placements",
    label: "Placements",
  },
  {
    value: "CutOffs",
    label: "CutOffs",
  },
  {
    value: "Ranking",
    label: "Ranking",
  },
  {
    value: "Campus",
    label: "Campus",
  },
  {
    value: "Reviews",
    label: "Reviews",
  },
  {
    value: "Fees",
    label: "Fees",
  },
];

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const ManageBlog = () => {
  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const data = [
    {
      state: "West Bangal",
      district: "North 24 Parganas",
      cityName: "Madhyamgram",
      type: "college",
      universityName: "Sikkim Manipal University",
      collegeName: "Lee Sun College",
      courseCategory: "Engineering",
      courseName: "Rocket Science",
      name: "Lee Sun College",
      shortDescription: "This is a good college",
      //   state: "West Bengal",
      //   district: "North 24 Parganas",
      address: "Barasat",
      pin: "700155",
      privateOrGovt: "Govt",
      estd: "1990",
      fees: "2600000",
      universityName: "Sikkim Manipal University",
      eligibility: "12th pass",
      applicationDate: "12th August 2025",

      longDescription:
        "hello hello hello hello hello hello hello hello hello hello hello hello hello hello hello hello ",
    },
  ];

  const initialValues = {
    collegeId: "",
    image: "",
    description: "",
    tabName: "",
    date: "",
  };

  const fileInputRef = useRef(null);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [uploading, setUploading] = useState(false);

  const [updateLoading, setUpdateLoading] = useState(false);
  const [updateId, setUpdateId] = useState(null);
  const [formData, setFormData] = useState(initialValues);

  const [fetchLoading, setFetchLoading] = useState(false);
  const [allData, setAllData] = useState([]);

  const fetchAllData = async () => {
    try {
      setFetchLoading(true);
      const res = await getBlog();
      console.log("FRE124", res?.data);
      if (res?.status) {
        setAllData(res?.data);
        setFetchLoading(false);
      } else {
        toast.error("Error while Fetching Course Fees Data");
        setFetchLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Course Fees Data");
      console.error("Error fetching Course Fees:", error);
      setFetchLoading(false);
    }
  };

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault();
    setUploading(true);
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, image: res.image });
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false);
      fileInputRef.current.value = null;
    }
  };

  const handleEdit = (data) => {
    setUpdateId(data?._id);
    const displayData = {
      collegeId: data?.college?._id || "",
      image: data?.image || "",
      description: data?.description || "",
      tabName: data?.tabName || "",
      date: data?.date ? moment(data.date).format("YYYY-MM-DD") : "",
    };
    setFormData(displayData);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete Blog?",
      text: "Are you sure you want to delete this Blog?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteBlog(id);
        Swal.fire("Deleted!", "Blog has been deleted.", "success");
        fetchAllData();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete Blog.", "error");
      }
    }
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Date",
      selector: (row) => moment(row.date).format("DD-MM-YYYY"),
      sortable: true,
      center: true,
    },
    {
      name: "College",
      selector: (row) => row?.college?.name,
      sortable: true,
      wrap: true,
    },
    {
      name: "Display Tab",
      selector: (row) => row?.tabName,
      sortable: true,
      wrap: true,
    },
    {
      name: "Image",
      selector: (row) => (
        <>
          <img
            src={row?.image}
            style={{ maxHeight: "100px", maxWidth: "100px", margin: "5px 0" }}
          />
        </>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Details",
      selector: (row) => {
        return getPlainTextFromHtml(row?.description, 10);
      },
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleEdit(row)}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
              onClick={() => handleDelete(row?._id)}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  const handleCancel = () => {
    setUpdateId(null);
  };

  const handleUpdate = async (e) => {
    e?.preventDefault();
    console.log("KJU388", formData);
    try {
      setUpdateLoading(true);
      const res = await updateBlog(updateId, formData);
      console.log("Blog Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        setFormData(initialValues);
        setUpdateId(null);
        setUpdateLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update Blog.");
      console.error("Error updating Blog:", error);
      setUpdateLoading(false);
    } finally {
      fetchAllData();
    }
  };

  useEffect(() => {
    fetchAllData();
    fetchColleges();
  }, []);

  return (
    <div>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Manage Blog
          </div>
          {updateId ? (
            <>
              <section className="chartBox_area">
                <form
                  onSubmit={(e) => {
                    handleUpdate(e);
                  }}
                >
                  <div className="row d-flex justify-content-center">
                    <div className="col-md-6 mt-3">
                      <label htmlFor="name">
                        College Name<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            collegeId: e?.target?.value,
                          }));
                        }}
                        value={formData?.collegeId}
                        className="form-control"
                      >
                        <option value="">
                          -------- Select College --------
                        </option>
                        {fetchCollegesLoading ? (
                          <option>Loading...</option>
                        ) : colleges?.length === 0 ? (
                          <option>No College Found</option>
                        ) : (
                          colleges.map((e, i) => {
                            return (
                              <option key={i} value={e?._id}>
                                {e?.name}
                              </option>
                            );
                          })
                        )}
                      </select>
                    </div>

                    <div className="col-md-3 mt-3">
                      <label htmlFor="name">
                        Display Tab<span className="text-danger">*</span>
                      </label>
                      <select
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            tabName: e?.target?.value,
                          }));
                        }}
                        value={formData?.tabName}
                        className="form-control"
                      >
                        <option value="">-------- Select Tab --------</option>
                        {tabNames.map((e, key) => {
                          return <option value={e.value}>{e.label}</option>;
                        })}
                      </select>
                    </div>

                    <div className="col-md-3 mt-3">
                      <label htmlFor="name">
                        Post Date<span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        value={formData?.date}
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            date: moment(e?.target?.value).format("YYYY-MM-DD"),
                          }));
                        }}
                        placeholder="Applicaion Date"
                      />
                    </div>

                    <div className="col-md-12 mt-3">
                      <label htmlFor="Brochure">
                        {uploading && "Uploading "} Photo
                      </label>
                      {!uploading && formData?.image && (
                        <>
                          <img
                            src={formData?.image}
                            alt="Photo Preview"
                            style={{
                              display: "block",
                              margin: "10px 0",
                              maxHeight: "100px",
                            }}
                          />
                        </>
                      )}
                      <input
                        type="file"
                        ref={fileInputRef}
                        className="form-control"
                        onChange={handleFileUpload}
                        accept="image/*"
                      />
                    </div>

                    <div className="col-md-12 mt-3">
                      <label htmlFor="longDescription">
                        Blog/News Description
                      </label>
                      <ReactQuill
                        modules={modules}
                        theme="snow"
                        value={formData?.description}
                        onChange={(value) => {
                          setFormData((prev) => ({
                            ...prev,
                            description: value,
                          }));
                        }}
                        placeholder="Enter Details"
                        style={{
                          height: "150px",
                          marginBottom: "40px",
                          fontFamily: "Poppins",
                          fontSize: "1rem",
                        }}
                      />
                    </div>
                  </div>
                  {/* <div className=" d-flex justify-content-center">
                              <button
                                type="button"
                                className="btn mt-3"
                                style={{
                                  background: "#a2bae0",
                                  borderRadius: "13px",
                                }}
                              >
                                Add More
                              </button>
                            </div> */}
                  <div
                    className=" d-flex justify-content-center"
                    style={{ gap: "15px" }}
                  >
                    <button
                      disabled={updateLoading}
                      type="submit"
                      className="btn mt-3"
                      style={{
                        background: "rgb(133, 218, 79)",
                        borderRadius: "13px",
                      }}
                    >
                      {updateLoading ? "Saving data..." : "Update Blog"}
                    </button>
                    <button
                      onClick={() => {
                        handleCancel();
                      }}
                      disabled={updateLoading}
                      type="button"
                      className="btn mt-3"
                      style={{
                        background: "#f77754",
                        borderRadius: "13px",
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </section>
            </>
          ) : (
            <>
              <section className="chartBox_area">
                <DataTable
                  data={allData}
                  columns={columns}
                  pagination
                  responsive
                  highlightOnHover
                  customStyles={customStyles}
                />
              </section>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageBlog;
